module.exports = __webpack_public_path__ + "c3cf2a7eb775ecdcd1b570907804cab0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/heldenkult.svg
// module id = 17
// module chunks = 0